/* eslint-disable no-unused-vars */
import React, { Suspense, useState, useEffect } from 'react'
import { AsistenciaSeccion1 } from './AsistenciaSeccion1'
import StepWizard from 'react-step-wizard'
import { Grid } from '@material-ui/core'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { useAsistencia } from '../../../context/AsistenciaContext'
import { AsistenciaSeccion2 } from './AsistenciaSeccion2'
import { AsistenciaSeccion3 } from './AsistenciaSeccion3'
import { useFormTechnicalAssistance } from '../../../context/TechnicalAssistanceContext'
import { GetTechnicalAssistanceAnswers } from '../../../services/AsistenciaTecnica/get'

const AsistenciaTecnica = ({ idForm, edit }) => {
  const [state, dispatch, enableSec3] = useAsistencia()
  const [loading, setLoading] = useState(true)
  const { setAssistanceForm } = useFormTechnicalAssistance()

  const getEditFormTechnicalAssistance = async (idForm) => {
    try {
      const response = await GetTechnicalAssistanceAnswers(idForm)
      if (response.Success) setAssistanceForm(response.Data)
      setLoading(false)
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (edit) {
      getEditFormTechnicalAssistance(idForm)
    } else {
      setLoading(false)
    }
  }, [])

  return (
    <>
      {!loading ? (
        <div
          id="wizard-form"
          style={{
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
          }}
        >
          <Grid
            container
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '36px' }}
          >
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 1
                  ? // step === 1
                    `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 1</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 2
                  ? // step === 1
                    `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 2</label>
            </Grid>
            {enableSec3 ? (
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                className={`${
                  state.step === 3
                    ? // step === 1
                      `stepper__title-active`
                    : `stepper__title-inactive`
                }`}
              >
                <label>SECCIÓN 3</label>
              </Grid>
            ) : (
              ''
            )}
          </Grid>

          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  width: '80%',
                  height: '80vh',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </div>
            }
          >
            <StepWizard initialStep={1}>
              <AsistenciaSeccion1 edit={edit} idForm={idForm} />
              <AsistenciaSeccion2 edit={edit} idForm={idForm} />
              {enableSec3 ? (
                <AsistenciaSeccion3 edit={edit} idForm={idForm} />
              ) : (
                ''
              )}
            </StepWizard>
          </Suspense>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}

export default AsistenciaTecnica
